$.fn.slideRight = function (speed, fn) {
  return $(this).animate(
    {
      left: 0
    },
    speed || 400,
    function () {
      $('body').addClass('overflow-y-hidden');
      $.isFunction(fn) && fn.call(this);
    }
  );
};

$.fn.slideLeft = function (speed, fn) {
  return $(this).animate(
    {
      left: '-80%'
    },
    speed || 400,
    function () {
      $('body').removeClass('overflow-y-hidden');
      $.isFunction(fn) && fn.call(this);
    }
  );
};

$(document).ready(function () {
  const meun = $('.js-menu');
  const sidebar = $('.js-sidebar');
  const arrow = $('.js-sidebar-arrow');
  const searchBtn = $('.js-top-search');
  const searchModal = $('.js-search-modal');
  const searchclosebtn = $('.js-close-search-modal');
  const toggleBtns = $('.js-search-categroy-toggle');
  // const minusBtns = $('.js-search-category-minus');
  const categoryContents = $('.js-search-category-content');
  const overlay = $('#t-fullscreen-overlay');
  const sidebarCategoryBtn = $($('#t-meun-links .js-sidebar-1')[0]);
  const sidebarSearchBtn = $($('#t-meun-links .js-sidebar-2')[0]);

  const TOWEL_TIME = {
    LONG: 900,
    MIDDLE: 500,
    SHORT: 200
  };

  const TOGGLE_STATUS = {
    SIDEBAR_OPEN: false
  };

  overlay.on('click', () => {
    sidebar.slideLeft(TOWEL_TIME.MIDDLE);
    searchModal.slideUp(TOWEL_TIME.SHORT, 'linear');
    overlay.hide();
    TOGGLE_STATUS.SIDEBAR_OPEN = false;
  });

  arrow.on('click', function () {
    sidebar.slideLeft(TOWEL_TIME.MIDDLE);
    overlay.hide();
    TOGGLE_STATUS.SIDEBAR_OPEN = false;
  });

  meun.on('click', function () {
    sidebar.slideRight(TOWEL_TIME.MIDDLE);
    overlay.show();
    setTimeout(() => {
      TOGGLE_STATUS.SIDEBAR_OPEN = true;
    }, TOWEL_TIME.SHORT);
  });

  searchBtn.on('click', function () {
    searchModal.show();
    overlay.show();
  });

  searchclosebtn.on('click', function () {
    searchModal.hide();
    overlay.hide();
  });

  toggleBtns.map((index, toggleBtn) => {
    $(toggleBtn).on('click', () => {
      $(categoryContents[index]).slideToggle();
      if ($(toggleBtn).text().trim() == '-') {
        $(toggleBtn).text('+');
      } else {
        $(toggleBtn).text('-');
      }
    });
  });

  [sidebarCategoryBtn, sidebarSearchBtn].forEach((btn, index) => {
    btn.on('click', (e) => {
      e.preventDefault();
      sidebar.slideLeft(TOWEL_TIME.MIDDLE);
      TOGGLE_STATUS.SIDEBAR_OPEN = false;
      searchModal.show();
      overlay.show();
      searchModal.get(0).scrollIntoView({ behavior: 'smooth' });
      if (index) {
        $('.js-search-modal input').first().focus();
      }
    });
  });

  // if (window.innerWidth < 768 && location.pathname === '/') {
  //   if ($('.js-top-brand')[6]) $('.js-top-brand')[6].style.display = 'none';
  // }

  // toggleFaq.map((index, toggleBtn) => {
  //   $(toggleBtn).on('click', () => {
  //     $(categoryContents[index]).slideToggle();
  //     if ($(toggleBtn).text() === 'ー') {
  //       $(toggleBtn).text('＋');
  //     } else {
  //       $(toggleBtn).text('ー');
  //     }
  //   });
  // });
});

$(function () {
  $('a[href^="#"]').click(function () {
    var speed = 700;
    var href = $(this).attr('href');
    var target = $(href == '#' || href == '' ? 'html' : href);
    var position = target.offset().top - 200;
    $('html, body').animate({ scrollTop: position }, speed, 'swing');
    return false;
  });
});
